import { html } from 'lit';
import type { SvgIcon } from '../entities';

export const campaignManagement: SvgIcon = {
  key: '779f6ce9-346d-42de-b5ac-e278706a7542',
  icon: html` <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="var(--stroke, var(--uui-color-default))"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path d="m3 11 18-5v12L3 14v-3z" />
    <path d="M11.6 16.8a3 3 0 1 1-5.8-1.6" />
  </svg>`,
};
